import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { BadgesModel, ConsumerBadgeDetailsResponse } from "./type";

const initialState: BadgesModel = {
  badgeDetails: {
    _id: "",
    consumerId: "",
    badgeId: "",
    badgesDetails: {
      badgeName: "",
      normalizedBadgeName: "",
      totalXp: 0,
      icon: "",
    },
    status: "INACTIVE",
    created: 0,
    createdAt: "",
    updatedAt: "",
    totalXp: 0,
    unEarnBadges: {
      _id: "",
      badgeName: "",
      normalizedBadgeName: "",
      totalXp: 0,
      icon: "",
      status: "INACTIVE",
      totalUser: 0,
      created: 0,
      createdAt: "",
      updatedAt: "",
    },
  },

  earnedBadgesList: {
    data: [],
    total: 0,
    limit: 0,
    pageNo: 0,
    nextHit: 0,
    totalPage: 0,
  },

  earnedBadgesListQueryParams: {
    pageNo: 1,
    limit: 5,
  },
};

const BadgesSlice = createSlice({
  name: "Badges",
  initialState,
  reducers: {
    setBadgesDetailsData: (
      state: BadgesModel,
      action: PayloadAction<ConsumerBadgeDetailsResponse>,
    ) => {
      state.badgeDetails = action.payload;
    },

    setEarnedBadgesListData: (
      state: BadgesModel,
      action: PayloadAction<BadgesModel["earnedBadgesList"]>,
    ) => {
      if (action.payload.pageNo > 1) {
        state.earnedBadgesList = {
          ...action.payload,
          data: [...state.earnedBadgesList.data, ...action.payload.data],
        };
      } else {
        state.earnedBadgesList = action.payload;
      }
    },

    setEarnedBadgesListQueryParams: (
      state: BadgesModel,
      action: PayloadAction<
        Partial<BadgesModel["earnedBadgesListQueryParams"]>
      >,
    ) => {
      state.earnedBadgesListQueryParams = {
        ...state.earnedBadgesListQueryParams,
        ...action.payload,
      };
    },

    clearBadgesState: () => initialState,
  },
});

export const {
  clearBadgesState,
  setBadgesDetailsData,
  setEarnedBadgesListData,
  setEarnedBadgesListQueryParams,
} = BadgesSlice.actions;

export default BadgesSlice.reducer;
